import ReactDOM from 'react-dom';

const SubIndex = ({ children }) => {
  const el = document.getElementById('subRoot');
  return ReactDOM.createPortal(children, el);
};

export default SubIndex;
